<header class="navbar" id="header" *ngIf="!param">
  <div class="container row wrap" fxLayout="row wrap" fxLayoutAlign="start center">
      <div class="navbar-mobile-top" fxLayout="row" fxLayoutWrap="wrap" fxLayoutAlign="start center">
          <div class="navbar-logo">
              <a pageScroll href="#home" routerLink="/home"><img src="./assets/img/logo-gennius.svg" alt=""></a>
          </div>
          <div color="accent" class="navbar-toggle" (click)="toggleNavbar()">
              <mat-icon class="icono-animacion" [ngClass]="navbarOpened ? 'mostrar' : 'oculto'"></mat-icon>
          </div>
      </div>

    <div class="right">
        <nav class="top-navbar CAM" [routerLinkActive]="['active']">
            <a class="navbartop-btn" (click)="toggleNavbar()" pageScroll href="#solutions" [routerLink]="['/solutions']" [routerLinkActive]="['active']"><div>Solution</div></a>

            <!-- <a class="navbartop-btn" (click)="toggleNavbar()" pageScroll href="#cryptmi" [routerLink]="['/cryptmi']" [routerLinkActive]="['active']"><div>cryptMi</div></a> -->

            <a class="navbartop-btn" (click)="toggleNavbar()" pageScroll href="#visa-client" [routerLink]="['/visa-client']" [routerLinkActive]="['active']"><div>Visa Client</div></a>

            <a class="navbartop-btn" (click)="toggleNavbar()" pageScroll href="#mena-region" [routerLink]="['/mena-region']" [routerLinkActive]="['active']"><div>MENA Region</div></a>

            <a class="navbartop-btn" (click)="toggleNavbar()" pageScroll href="#the-world-as-one" [routerLink]="['/the-world-as-one']" [routerLinkActive]="['active']"><div>The World as One</div></a>

            <a class="navbartop-btn" (click)="toggleNavbar()" pageScroll href="#imagine-app" [routerLink]="['/imagine-app']" [routerLinkActive]="['active']"><div>Imagine App</div></a>

            <a class="navbartop-btn" (click)="toggleNavbar()" pageScroll href="#gmix" [routerLink]="['/gmix']" [routerLinkActive]="['active']"><div>One</div></a>

            <a class="navbartop-btn" (click)="toggleNavbar()" pageScroll href="#about" [routerLink]="['/about']" [routerLinkActive]="['active']"><div>About</div></a>

            <a class="navbartop-btn" (click)="toggleNavbar()" pageScroll href="#news" [routerLink]="['/news']" [routerLinkActive]="['active']"><div>Press</div></a>

            <a class="navbartop-btn btn-lets-start" (click)="toggleNavbar()" pageScroll href="#lets-start-the-conversation" [routerLink]="['/lets-start-the-conversation']" [routerLinkActive]="['active']"><div>Let’s Talk</div></a>

            <!-- <div class="btn-gennius" id="Request_a_demo_chat">
                Request a demo<span></span>
            </div> -->
        </nav>

    </div>

  </div>
</header>
